import React, { Component } from 'react';

import { authService } from '../../../services/auth';

import LoginNav from "./new-login-nav";
import './forgot-password.scss';

class ForgotPassword extends Component {
	constructor(props) {
		super(props);

		this.AuthService = authService;

		this.state = {
			email: '',
			emailSent: false,
			message: '',
		};
	}

	resetPassword(event) {
		event.preventDefault();
		const emailRegex = /\S+@\S+\.\S+/; // checks for string@string.string

		if (!this.state.email || !emailRegex.test(this.state.email)) {
			this.setState({message: 'Please enter a valid email address.'});
			return;
		}

		return this.AuthService.requestResetPassword(this.state.email).then(() => {
			this.setState({
				emailSent: true,
				message: '',
			});
		}).catch(() => {
			this.setState({message: 'Unable to request password reset.'});
		});
	}

	render() {
		const validEmail = (
			<p className={`warning ${this.state.message ? '' : 'disabled'}`}>
				{this.state.message}
			</p>
		);

		const pageContent = this.state.emailSent ? (
			<div className="reset-confirmation">
				<h1 className="reset-text">
					An email to reset your password has been sent to you.
				</h1>
				<div className="buttons">
					<a
						className="sign-in-btn"
						href="/v2/login">
						BACK TO SIGN IN
					</a>
				</div>
			</div>
		) : (
			<div className="main-content">
				<div className="instruction-text">
					<p className="forgot-password">
						Please fill in your email and click reset password.
						We will send you an email shortly.
					</p>
				</div>
				<div className="form-container">
					<form
						onSubmit={this.resetPassword.bind(this)}
						className="forgot-password-form">
						<div className="input-container">
							<label className="input-label">
								Email address
							</label>
							<input
								className="email"
								label="Email"
								type="text"
								value={this.state.email}
								onChange={(e) => this.setState({email: e.target.value})}
							/>
						</div>
						{validEmail}
						<div className="buttons">
							<button className="submit-btn">RESET PASSWORD</button>
							<a
								className="sign-in-btn"
								href="/v2/login">
								BACK TO SIGN IN
							</a>
						</div>
					</form>
				</div>
			</div>
		);

		return (
			<div className={`forgot-password${this.props.isMobile ? ' mobile' : ''}`}>
				<LoginNav isMobile={this.props.isMobile} />
				<div className="content">
					<div className="content-header">
						<span className="text">Forgot password</span>
						<span className="line"></span>
					</div>
					{pageContent}
				</div>
			</div>
		);
	}
}

export default ForgotPassword;
